/**
 * Map points for the About page.
 * MAG HQ: Livonia office. Plants: named MAG robot sites.
 * Partners/vendors: partner records plus additional vendor locations for the map.
 */
import { partners } from "./partners";

export const magHqSite = {
  id: "mag-hq",
  layer: "hq",
  name: "MAG HQ",
  detail: "35572 Veronica St, Livonia, MI 48150",
  label: "Livonia, MI",
  labelOffset: { x: 16, y: -18 },
  lat: 42.37725,
  lng: -83.39455,
};

export const plantSites = [
  {
    id: "plant-howell",
    layer: "plants",
    name: "Howell, MI",
    detail: "Plant site",
    label: "Howell, MI",
    labelOffset: { x: 16, y: -20 },
    lat: 42.6073,
    lng: -83.9294,
  },
  {
    id: "plant-sterling-heights",
    layer: "plants",
    name: "Sterling Heights, MI",
    detail: "Plant site",
    label: "Sterling Heights, MI",
    labelOffset: { x: 18, y: -16 },
    lat: 42.5803,
    lng: -83.0302,
  },
  {
    id: "plant-detroit",
    layer: "plants",
    name: "Detroit, MI",
    detail: "Plant site",
    label: "Detroit, MI",
    labelOffset: { x: 18, y: 2 },
    lat: 42.3314,
    lng: -83.0458,
  },
  {
    id: "plant-woodhaven",
    layer: "plants",
    name: "Woodhaven, MI",
    detail: "Plant site",
    label: "Woodhaven, MI",
    labelOffset: { x: 16, y: 18 },
    lat: 42.1325,
    lng: -83.2367,
  },
  {
    id: "plant-chicago",
    layer: "plants",
    name: "Chicago, IL",
    detail: "Plant site",
    label: "Chicago, IL",
    labelOffset: { x: -78, y: -16 },
    lat: 41.8781,
    lng: -87.6298,
  },
  {
    id: "plant-kansas-city",
    layer: "plants",
    name: "Kansas City, MO",
    detail: "Plant site",
    label: "Kansas City, MO",
    labelOffset: { x: 16, y: -12 },
    lat: 39.0997,
    lng: -94.5786,
  },
  {
    id: "plant-louisville",
    layer: "plants",
    name: "Louisville, KY",
    detail: "Plant site",
    label: "Louisville, KY",
    labelOffset: { x: 16, y: 10 },
    lat: 38.2527,
    lng: -85.7585,
  },
  {
    id: "plant-saudi-arabia",
    layer: "plants",
    name: "Riyadh, Saudi Arabia",
    detail: "Plant site",
    label: "Riyadh, Saudi Arabia",
    labelOffset: { x: 16, y: -8 },
    lat: 24.7136,
    lng: 46.6753,
  },
];

const extraVendorSites = [
  {
    id: "vendor-wheelme",
    layer: "partners",
    name: "wheel.me",
    detail: "Oslo, Norway",
    label: "wheel.me · Oslo, Norway",
    labelOffset: { x: 16, y: -14 },
    lat: 59.9139,
    lng: 10.7522,
  },
  {
    id: "vendor-otto",
    layer: "partners",
    name: "OTTO by Rockwell Automation",
    detail: "Kitchener, Ontario",
    label: "OTTO · Kitchener, Ontario",
    labelOffset: { x: 16, y: -14 },
    lat: 43.4516,
    lng: -80.4925,
  },
  {
    id: "vendor-sailrail",
    layer: "partners",
    name: "SailRail",
    detail: "Concord, Ontario",
    label: "SailRail · Concord, Ontario",
    labelOffset: { x: 16, y: 12 },
    lat: 43.7975,
    lng: -79.528,
  },
  {
    id: "vendor-kuka",
    layer: "partners",
    name: "KUKA",
    detail: "Augsburg, Germany",
    label: "KUKA · Augsburg, Germany",
    labelOffset: { x: 16, y: 12 },
    lat: 48.3705,
    lng: 10.8978,
  },
  {
    id: "vendor-hovair",
    layer: "partners",
    name: "Hovair Automotive",
    detail: "Wixom, MI",
    label: "Hovair Automotive · Wixom, MI",
    labelOffset: { x: -128, y: -12 },
    lat: 42.5248,
    lng: -83.5363,
  },
  {
    id: "vendor-nmh",
    layer: "partners",
    name: "Nichols Material Handling",
    detail: "Grand Rapids, MI",
    label: "Nichols Material Handling · Grand Rapids, MI",
    labelOffset: { x: 16, y: -14 },
    lat: 42.9634,
    lng: -85.6681,
  },
  {
    id: "vendor-universal-logistics",
    layer: "partners",
    name: "Universal Logistics",
    detail: "Warren, MI",
    label: "Universal Logistics · Warren, MI",
    labelOffset: { x: 18, y: 16 },
    lat: 42.5145,
    lng: -83.0146,
  },
  {
    id: "vendor-seer",
    layer: "partners",
    name: "SEER Robotics",
    detail: "Shanghai, China",
    label: "SEER Robotics · Shanghai, China",
    labelOffset: { x: 16, y: -12 },
    lat: 31.2304,
    lng: 121.4737,
  },
  {
    id: "vendor-slamcore",
    layer: "partners",
    name: "Slamcore",
    detail: "London, England",
    label: "Slamcore · London, England",
    labelOffset: { x: 16, y: 10 },
    lat: 51.5074,
    lng: -0.1278,
  },
  {
    id: "vendor-novares-mexico",
    layer: "partners",
    name: "Novares",
    detail: "Mexico City, Mexico",
    label: "Novares · Mexico City, Mexico",
    labelOffset: { x: 16, y: 10 },
    lat: 19.4326,
    lng: -99.1332,
  },
  {
    id: "vendor-novares-france",
    layer: "partners",
    name: "Novares",
    detail: "Clamart, France",
    label: "Novares · Clamart, France",
    labelOffset: { x: -118, y: -10 },
    lat: 48.8066,
    lng: 2.2626,
  },
];

function abbMapHeadquarters() {
  return {
    city: "Spain",
    country: "Spain",
    lat: 40.4168,
    lng: -3.7038,
  };
}

export function partnerMapSites() {
  const fromPartners = partners
    .filter((partner) => partner.headquarters)
    .map((partner) => {
      const hq = partner.slug === "abb" ? abbMapHeadquarters() : partner.headquarters;
      return {
        id: `partner-${partner.slug}`,
        layer: "partners",
        name: partner.name,
        detail: `${hq.city}, ${hq.country}`,
        label: `${partner.name} · ${hq.city === hq.country ? hq.country : `${hq.city}, ${hq.country}`}`,
        labelOffset: { x: 16, y: 0 },
        lat: hq.lat,
        lng: hq.lng,
      };
    });

  return [...fromPartners, ...extraVendorSites];
}

export const mapLayers = [
  { id: "hq", label: "MAG HQ" },
  { id: "partners", label: "Partners" },
  { id: "plants", label: "Plants" },
];
